import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import MuiBox from '@mui/material/Box';
import { extractSystemStyles } from '@famly/mf_system_system-props';
import { useDataProps } from '@famly/mf_ts-utils_data-aria-props';
export const Box = (props) => {
    const { component, children, ref, ...rest } = props;
    const dataProps = useDataProps(rest);
    const { sx, nonSystemProps } = extractSystemStyles(rest);
    const _props = { ...dataProps, sx, component, ...nonSystemProps };
    return (_jsx(MuiBox, { ..._props, ref: ref, children: children }));
};
Box.displayName = 'Box';
export const createBox = (outerProps) => {
    return (innerProps) => {
        const props = { ...outerProps, ...innerProps };
        return _jsx(Box, { ...props });
    };
};
